import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';
import { StyleObject } from 'styletron-react';

export const PURPLE: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.primary400,
      fontWeight: 700,
      fontSize: '14px',
      alignItems: 'center',
      display: 'flex',
    },
  },
};

const NORMAL_BASE: StyleObject = {
  fontSize: '14px',
  lineHeight: 1.75,
  fontWeight: 400,
  whiteSpace: 'pre-wrap',
};

export const NORMAL: BlockOverrides = {
  Block: {
    style: NORMAL_BASE,
  },
};

export const NORMAL_FADED: BlockOverrides = {
  Block: {
    style: {
      ...NORMAL_BASE,
      maxHeight: '240px',
      overflow: 'hidden',
      content: '',
      background: 'linear-gradient(#fff 60%, transparent)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
};

export const FEATURED_CONTAINER: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '32px',

      [THEME.media.large]: {
        gridTemplateColumns: '1.8fr 2fr',
        gridColumnGap: '32px',
        gridRowGap: 0,
      },
    },
  },
};

export const ROOT: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '32px',

      [THEME.media.large]: {
        gridTemplateColumns: '1fr auto',
        gridColumnGap: '24px',
        alignItems: 'center',
        gridRowGap: 0,
      },
    },
  },
};
